import axios from "../../config/axiosConfig";
import { CREATE_JOB, GET_JOB, JOB_REQUEST, DELETE_JOB, UPDATE_JOB, JOB_REQUEST_FAILURE } from "../types";
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getJobs = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/job/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createJob = (job) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: JOB_REQUEST });
      return axios.post("/job/add", job,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_JOB, payload: response.data });
          dispatch(addMasterInOption('jobs', response.data));
        } else {
          dispatch({
            type: JOB_REQUEST_FAILURE,
            error: "Job create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateJob = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_REQUEST });
      const { auth } = getState();
      return axios.put("/job/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_JOB,
            payload: { id, data: response.data },
          });
          dispatch(updateMasterInOption('jobs', id, response.data));
        } else {
          dispatch({
            type: JOB_REQUEST_FAILURE,
            error: "Job update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteJob = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: JOB_REQUEST });
      return axios.delete(`/job/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_JOB, id: id });
          dispatch(updateMasterInOption('jobs', id));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
